import type { ReactNode } from 'react'
import { MarkdownLite } from '@/components/chat/MarkdownLite'
import { cn } from '@/lib/utils'

/**
 * One chat turn (user right, assistant left) — extracted from Journey's
 * ChatPanel (spec-27) so the global Sparky copilot (spec-29) renders the same
 * bubbles. Purely presentational: `inside` renders within the bubble (e.g.
 * attachment chips), `below` renders under it (e.g. "Vragen van Sparky" or
 * citation badges).
 */
export function ChatMessageBubble({
  isUser,
  content,
  markdown = false,
  inside,
  below,
}: {
  isUser: boolean
  content: string
  /** Render `content` through the lite markdown renderer (assistant prose). */
  markdown?: boolean
  inside?: ReactNode
  below?: ReactNode
}) {
  return (
    <li className={cn('flex', isUser ? 'justify-end' : 'justify-start')}>
      <div className={cn('flex max-w-[85%] flex-col gap-2', isUser ? 'items-end' : 'items-start')}>
        <div
          className={cn(
            'rounded-2xl px-3 py-2 text-sm',
            isUser
              ? 'bg-primary text-primary-foreground'
              : 'border border-border bg-white text-foreground',
          )}
        >
          {content && markdown ? (
            <MarkdownLite>{content}</MarkdownLite>
          ) : content ? (
            <p className="whitespace-pre-wrap">{content}</p>
          ) : (
            <p className="italic text-muted-foreground">…</p>
          )}
          {inside}
        </div>
        {below}
      </div>
    </li>
  )
}
